import axiosInstance from "../../scenes/utils/axiosInstance";
import { API_ENDPOINTS } from "../../config/api";

export default class FormService {
  createForm = async (data) => {
    try {
      const response = await axiosInstance.post(
        API_ENDPOINTS.FORMS.CREATE,
        data
      );
      return response.data;
    } catch (error) {
      console.error("Bir sorun oluştu:", error.response?.data || error.message);
      throw error; // Yukarıda da try/catch varsa, orada yakalanır
    }
  };

  getFormInfo = async (formId) => {
    try {
      const response = await axiosInstance.get(
        API_ENDPOINTS.FORMS.BY_ID(formId)
      );
      return response.data;
    } catch (error) {
      console.log("Bir sorun oluştu: ", error.response?.data || error.message);
      throw error;
    }
  };
  updateForm = async (formId, updatedFormData) => {
    try {
      const response = await axiosInstance.put(
        API_ENDPOINTS.FORMS.UPDATE(formId),
        updatedFormData
      );
      return response.data;
    } catch (error) {
      console.error("Bir sorun oluştu:", error.response?.data || error.message);
      throw error;
    }
  };
  formAnswer = async (data) => {
    try {
      const response = await axiosInstance.post(
        API_ENDPOINTS.FORM_ANSWERS.CREATE,
        data
      );
      return response.data;
    } catch (error) {
      console.error("Bir sorun oluştu:", error.response?.data || error.message);
      throw error;
    }
  };
  getAllForms = async () => {
    try {
      const response = await axiosInstance.get(API_ENDPOINTS.FORMS.ALL);
      return response.data;
    } catch (error) {
      console.error("Bir sorun oluştu:", error.response?.data || error.message);
      throw error;
    }
  };
  getAllFormAnswers = async () => {
    try {
      const response = await axiosInstance.get(
        API_ENDPOINTS.FORM_ANSWERS.ALL
      );
      return response.data;
    } catch (error) {
      console.error("Bir sorun oluştu:", error.response?.data || error.message);
      throw error;
    }
  };
  getAnsweredFormInfo = async (formId) => {
    try {
      const response = await axiosInstance.get(
        API_ENDPOINTS.FORM_ANSWERS.BY_ID(formId)
      );
      return response.data;
    } catch (error) {
      console.error("Bir sorun oluştu:", error.response?.data || error.message);
      throw error;
    }
  };

  exportAnsweredFormExcel = async (formId) => {
    try {
      const response = await axiosInstance.get(
        API_ENDPOINTS.FORM_ANSWERS.EXPORT_EXCEL(formId),
        { responseType: "blob" }
      );
      return response;
    } catch (error) {
      console.error("Bir sorun oluştu:", error.response?.data || error.message);
      throw error;
    }
  };

  deleteForm = async (formId) => {
    try {
      const response = await axiosInstance.delete(
        API_ENDPOINTS.FORMS.DELETE(formId)
      );
      return response.data;
    } catch (error) {
      console.error("Bir sorun oluştu:", error.response?.data || error.message);
      throw error;
    }
  };

  sendFormEmail = async (data, formId) => {
    try {
      const response = await axiosInstance.post(
        API_ENDPOINTS.FORMS.INVITATIONS(formId),
        data
      );
      return response.data;
    } catch (error) {
      console.error("Bir sorun oluştu:", error.response?.data || error.message);
      throw error;
    }
  };

  getPublicFormInfo = async (formToken) => {
    try {
      const response = await axiosInstance.get(
        API_ENDPOINTS.PUBLIC.FORM(formToken)
      );
      return response.data;
    } catch (error) {
      console.error("Bir sorun oluştu:", error.response?.data || error.message);
      throw error;
    }
  };

  formAnswerPublic = async (data) => {
    try {
      const response = await axiosInstance.post(
        API_ENDPOINTS.PUBLIC.FORM_ANSWER,
        data
      );
      return response.data;
    } catch (error) {
      console.error("Bir sorun oluştu:", error.response?.data || error.message);
      throw error;
    }
  }
getFormInvitations = async (formId) => {
    try {
      const response = await axiosInstance.get(
        API_ENDPOINTS.FORMS.BY_ID(formId)
      );
      // Backend'ten gelen patients array'inden tüm invitations'ları topla
      const allInvitations = [];
      if (response.data.patients) {
        response.data.patients.forEach(patient => {
          if (patient.invitations && patient.invitations.length > 0) {
            allInvitations.push(...patient.invitations);
          }
        });
      }
      return allInvitations;
    } catch (error) {
      console.error("Bir sorun oluştu:", error.response?.data || error.message);
      throw error;
    }
  };

  getPatientInvitations = async (patientId) => {
    try {
      const response = await axiosInstance.get(
        API_ENDPOINTS.PATIENTS.INVITATIONS(patientId)
      );
      return response.data;
    } catch (error) {
      console.error("Bir sorun oluştu:", error.response?.data || error.message);
      throw error;
    }
  };
}